import React, { useEffect } from 'react';

import { useState } from 'react';

import "../../style/queue.css";

import { RuntimeContextProvider } from '../../context/runtime-context';

// Generic compoennts
import NeoLayout from '../../components/neoLayout';
import NeoIcon from '../../components/neoIcon';
import NeoInfo from '../../components/neoInfo';
import NeoImage from '../../components/neoImage';
import NeoVideo from '../../components/neoVideo';
import NeoQueue from '../../components/neoQueue';
import { NeoCountDownSeconds } from '../../components/neoCountDown';
import NeoRecaptcha from '../../components/neoRecaptcha';
import MultiEvent from '../../components/multi-event';
import NeoText from '../../components/neoText';
import { StandaloneLoader } from '../../components/neoLoader';
import FormStep from '../formStep';
import UpdateTicketForm from '../../components/update-ticket-form/update-ticket-form';
// Specific Components
import { OrderMenu } from '../../components/order-menu/order-menu';
import { TicketMenu } from '../../components/ticket-menu/ticket-menu';
import StepPayment from '../../components/payment/payment';
import TicketView from '../../components/ticket-card/ticket-confirm';
import CreateResale from '../../components/resale/seller/create';
import EditResale from '../../components/resale/seller/edit';
import DeleteResale from '../../components/resale/seller/delete';
import ResaleMenu from '../../components/resale/seller/resale-menu';
import TicketMarketResale from '../../components/resale/buyer/ticketMarket';
import TicketCart from '../../components/resale/buyer/ticketCart';
import EventCard from "../../components/jo-components/cards/eventCard/eventCard";
import TicketMarket from "../../components/jo-components/steps/ticket_market/ticketMarket";
import NewFormStep from "../../components/jo-components/steps/form_step/formStep";
import StepHeader from "../../components/jo-components/misc/stepHeader/stepHeader";
import CartStep from "../../components/jo-components/steps/cart_step/cartStep";
import { ErrorMessage, ConfirmMessage, InfoMessage } from "../../components/jo-components/misc/message/message";
import ConfirmStep from '../../components/jo-components/steps/confirm_step/confirmStep';
import Timer from '../../components/jo-components/misc/timer/timer';
// import ExpirationModal from "../../components/jo-components/misc/timer/expirationModal";
// import {useInterval} from "../../hooks/hooks";
// import {getRemainingTime, getSimpleRemainingTime} from "../../components/resale/buyer/components/timer";
// import {useTranslation} from "react-i18next";
import WaitingListTicket from '../../components/waiting-list/waitingListTicket';
import WaitingListForm from '../../components/waiting-list/waitingListForm';
import WaitingListConfirmation from '../../components/waiting-list/waitingListConfirmation';
import { HomeEventStep } from '../../components/home/homeStep';
import { WaitingListTicketMenu } from '../../components/waitingListTicketMenu/waitingListTicketMenu';
import ModerationUpdateTicketForm from "../../components/moderation-ticket-update-form/moderation-ticket-update-form";
import LogoutButton from '../../components/jo-components/misc/logout-button/logoutButton';
import EventList from '../../components/personal-space/steps/events_list/eventsList';
import TransferFormStep from '../../components/jo-components/steps/transferFormStep/transferFormStep';
import { TicketCard } from '../../components/jo-components/cards/ticketCard/ticketCard';

const COMPONENTS_MAPPING = {
    'title': NeoLayout.Header,
    'subtitle': NeoLayout.Subtitle,
    'message': NeoLayout.Message,
    'info': NeoInfo,
    'description': NeoLayout.Description,
    'form': FormStep,
    'icon': NeoIcon,
    'video': NeoVideo,
    'image': NeoImage,
    'queue': NeoQueue,
    'recaptcha': NeoRecaptcha,
    'multi': MultiEvent,
    'loader': StandaloneLoader,
    'countdown': NeoCountDownSeconds,
    'text': NeoText,
    'logout_button': LogoutButton,
    // Specific steps
    // homeStep is depreciated
    'home_step': HomeEventStep,
    'home_event_step': HomeEventStep,
    'order-menu': OrderMenu,
    'ticket-menu': TicketMenu,
    'update-ticket-form': UpdateTicketForm,
    'payment': StepPayment,
    'ticket-view': TicketView,
    'resale-ticket-create-form': CreateResale,
    'resale-ticket-update-form': EditResale,
    'resale-ticket-delete-form': DeleteResale,
    'resale-menu': ResaleMenu,
    'ticket-market-rates': TicketMarketResale,
    'ticket-market-confirm': TicketCart,
    'generic_form': TransferFormStep,
    'ticket_card': TicketCard,
    //Layout components
    'form_instructions': InfoMessage,
    'error_messages': ErrorMessage,
    'confirm_message': ConfirmMessage,
    'step_header': StepHeader,
    'event_header': EventCard,
    'timer_settings': Timer,
    //Steps new engine
    'ticket_market': TicketMarket,
    'form_step': NewFormStep,
    'confirmation_detail': ConfirmStep,
    'cart_step': CartStep,
    'events_list': EventList,
    //Waiting list
    'waiting_list_ticket': WaitingListTicket,
    'waiting_list_form': WaitingListForm,
    'waiting_list_confirmation': WaitingListConfirmation,
    'waiting_list_menu': WaitingListTicketMenu,
    'moderation-ticket-update-form': ModerationUpdateTicketForm
};

const sort_elements = (data) => {
    let new_elements = {};

    // Loader first
    if (data.loader) {
        new_elements['loader'] = data.loader;
    }

    // Step header first
    if (data.step_header) {
        new_elements['step_header'] = data.step_header;
    }

    // Title first
    if (data.title) {
        new_elements['title'] = data.title;
    }

    // Then subtitle
    if (data.subtitle) {
        new_elements['subtitle'] = data.subtitle;
    }

    // Then message
    if (data.message) {
        new_elements['message'] = data.message;
    }

    // Then info
    if (data.info) {
        new_elements['info'] = data.info;
    }

    // Then description
    if (data.description) {
        new_elements['description'] = data.description;
    }


    for (let k in data) { // eslint-disable-line no-unused-vars
        if (['title', 'subtitle', 'message', 'info', 'description'].includes(k)) {
            continue;
        }

        new_elements[k] = data[k];
    }

    return new_elements;
}

const StepComponents = ({ data, props = {}, step, storage }) => {
    let new_elements = null;
    if (Array.isArray(data)) {
        new_elements = data;
    } else {
        new_elements = sort_elements(data);
        new_elements = Object.entries(new_elements).map(([type, value]) => {
            return {
                [type]: value
            };
        });
    }

    let elements = new_elements.map((element, index) => {
        // Take type and config from first element beacause only 1 should be there
        let [[type, config]] = Object.entries(element);
        const Component = COMPONENTS_MAPPING[type];
        if (!Component) {
            return null;
        }

        let newConf = config;
        if (!Array.isArray(config)) {
            newConf = [newConf];
        }

        if (type === 'form') {
            // Form is always an array
            return <Component
                key={`${type}-${index}`}
                step={step}
                config={{ [type]: config }}
                {...props}
            />;
        }

        return newConf.map((item_conf, i) => {
            return <Component
                key={`${type}-${index}-${i}`}
                step={step}
                config={{ [type]: item_conf }}
                {...props}
            />;
        });
    });

    let has_form = data.form || (Array.isArray(data) && data.find(element => Object.keys(element)[0] === 'form'));
    if (!has_form && (step.reset_allowed || step.skip_allowed || step.previous_allowed)) {
        elements.push(
            <NeoLayout.Footer
                key={step}
                step={step}
                storage={storage}
                {...props}
            />
        );
    }
    return elements;
};

// function Countdown({ input }) {
//     const { t } = useTranslation();
//
//     const [delay, setDelay] = React.useState(1000);
//     const [remainingTime, setRemainingTime] = React.useState(getSimpleRemainingTime(input?.exp));
//
//     useInterval(() => setRemainingTime(getRemainingTime(input?.exp, setDelay)), delay);
//     return <ExpirationModal
//         open={remainingTime === 0}
//         title={t("widget.expiration_modal.title_modal_expired_time")}
//         body={t("widget.expiration_modal.description_modal_expired_time")}
//         ctaLabel={t("widget.expiration_modal.cta_modal_expired_time")}
//     />;
// }

export default function GenericStep({ step, input, token, onSubmit, onPreviousStep, onSkip, onLeave, widgetKey, storage = null, waitingTime, lang = null, changeLanguage, widget = null, isSubmitting = false, isGoingBack = false, isMapped = true }) {
    let props = {
        lang,
        changeLanguage,
        input,
        token,
        onSkip,
        onSubmit,
        onLeave,
        onPreviousStep,
        widgetKey,
        widget,
        storage,
        waitingTime,
        isSubmitting,
        isGoingBack,
        isMapped
    };
    /* Prequeue handling */
    // If current step contains a queue + a coutdown
    // Then display the countdown until it's over and then display queue
    const [countdown, setCountdown] = useState(() => {
        if ('queue' in step.data && 'countdown' in step.data) {
            return step.data.countdown;
        }
        return null;
    });

    useEffect(() => {
        if (step.data.queue && step.data.countdown?.countdown) {
            const idTimeout = setTimeout(() => {
                setCountdown(null);
            }, step.data.countdown.countdown*1000);
            return () => clearTimeout(idTimeout);
        }
    }, []);

    const data = React.useMemo(() => {
        if (countdown) {
            return countdown;
        }
        if (!step.data) {
            return {};
        }
        return step.data;

    },[step, step.data, countdown])

    return (
        <RuntimeContextProvider>
            {/*<Countdown input={input} />*/}
            <StepComponents data={data} props={props} step={step} storage={storage} />
        </RuntimeContextProvider>
    );
}
